import { useMemo } from "react";

import { buildMuscleCoverage } from "./muscleCoverage";
import type { ProgressDeps } from "./types";
import { useSessionResultsFromDeps } from "./useSessionResults";

// The coverage census from a host's ProgressDeps: the SAME single-flight
// session results the panels read, scored the same way. Lifted out of
// ProgressView so the Create hub's «Build today's session» (AP-9b) reads the
// gaps the Progress card shows, and not a second computation of them.
export function useMuscleCoverage(deps: ProgressDeps) {
  const { results, catalog, error, status } = useSessionResultsFromDeps(deps);
  const coverage = useMemo(
    () =>
      results && catalog
        ? buildMuscleCoverage(
            results,
            catalog,
            deps.pinnedProgram ?? null,
            deps.prescription ?? null,
            Date.now(),
            deps.weekStartDay,
            deps.athleteTargets ?? null,
            deps.trainingPlace,
          )
        : null,
    [
      results,
      catalog,
      deps.pinnedProgram,
      deps.prescription,
      deps.weekStartDay,
      deps.athleteTargets,
      deps.trainingPlace,
    ],
  );
  return { coverage, results, catalog, error, status };
}
